import { useNavigate, Link } from "react-router-dom";
import PageHeader from "../../components/layout/PageHeader";
import { useShop } from "../../context/ShopContext";

export default function Checkout() {
  const { cart, cartTotal, clearCart } = useShop();
  const navigate = useNavigate();

  const placeOrder = (e) => {
    e.preventDefault();
    clearCart();
    navigate("/order-confirmation");
  };

  return (
    <>
      <PageHeader title="Checkout" crumbs={[{ label: "Cart", to: "/cart" }, { label: "Checkout" }]} />
      <section className="section">
        <div className="container">
          {cart.length === 0 ? (
            <div className="empty-state">
              <h3>Your Cart is Empty</h3>
              <p>Add products before checking out.</p>
              <Link to="/shop-grid" className="btn btn-primary">Go to Shop</Link>
            </div>
          ) : (
            <form className="cart-layout" onSubmit={placeOrder}>
              <div className="card" style={{ padding: 32 }}>
                <h3 style={{ marginBottom: 22 }}>Billing Details</h3>
                <div className="form-row">
                  <div className="field"><label>First Name</label><input required /></div>
                  <div className="field"><label>Last Name</label><input required /></div>
                </div>
                <div className="form-row">
                  <div className="field"><label>Email</label><input type="email" required /></div>
                  <div className="field"><label>Phone</label><input type="tel" required /></div>
                </div>
                <div className="field"><label>Address</label><input required /></div>
                <div className="form-row">
                  <div className="field"><label>City</label><input required /></div>
                  <div className="field"><label>Zip Code</label><input required /></div>
                </div>
                <h3 style={{ margin: "20px 0 18px" }}>Payment Method</h3>
                <div className="field">
                  <label><input type="radio" name="pay" defaultChecked /> Credit / Debit Card</label>
                </div>
                <div className="field">
                  <label><input type="radio" name="pay" /> Cash on Delivery</label>
                </div>
              </div>

              <div className="cart-summary">
                <h3>Your Order</h3>
                {cart.map((i) => (
                  <div className="summary-row" key={i.id}>
                    <span>{i.name} × {i.qty}</span>
                    <span>${(i.price * i.qty).toFixed(2)}</span>
                  </div>
                ))}
                <div className="summary-row"><span>Tax (5%)</span><span>${(cartTotal * 0.05).toFixed(2)}</span></div>
                <div className="summary-row total"><span>Total</span><span>${(cartTotal * 1.05).toFixed(2)}</span></div>
                <button type="submit" className="btn btn-primary btn-block mt-3">Place Order</button>
              </div>
            </form>
          )}
        </div>
      </section>
    </>
  );
}
